import {atom} from "recoil"

const selectedTransactionIdState = atom({
  key: 'selectedTransactionState',
  default: null
})

export default selectedTransactionIdState